import { cookies } from 'sharedKernel/cookies/behavior'

export const isUserOwner = (ownerId: string): boolean => {
  const credentials = cookies.get('_cred')
  
  if (!credentials || !credentials.data) {
    return false
  }
  
  const userId = credentials.data.id
  
  if (!userId) {
    return false
  }
  
  return userId === ownerId
}
